define((require) => {
    "use strict";

    const Backbone                          = require("backbone");
    const DashboardContentCollectionView    = require("ui/dashboard/DashboardContentCollectionView");
    const ProjectDashboardContentItemView   = require("ui/projects/content/ProjectDashboardContentItemView");
    const $                                 = require("jquery");

    /**
     *
     * @class ProjectDashboardContentCollectionView
     */
    return DashboardContentCollectionView.extend({

        itemView: ProjectDashboardContentItemView,

        itemViewOptions: function() {
            return {
                projectContext: this.options.projectContext
            };
        },

        itemEvents: {
            "detach": function(model) {
                this.collection.remove(model);
            }
        },

        /**
         * Returns the options passed to the "Create new experience" item view. In the case
         * of a project, we want to change the wording.
         *
         * @return {*} The options:
         *             @cfg label The text to display.
         *             @cfg onClick The event to fire when clicked.
         */
        createLabelOptions: function() {
            return {
                label: "Create<br>New Experience<br>In Project<br>&#43;",
                onClick: () =>
                    Backbone.history.navigate(`experience/create/project/${this.options.projectContext.project.id}`, {trigger: true})
            };
        },

        onRender: function() {
            const $attachButton = $("<button class='attach-button btn btn-grey pull-right'>Attach</button>");

            // Disable attach button if insufficient privileges...
            if (this.options.spectatorMode) {
                $attachButton.addClass("disabled").attr("disabled", true);
            } else {
                $attachButton.click(() => {
                    this.viewScope.openAttachLightbox();
                });
            }

            this.$el.prepend($attachButton);
        },

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset: function() {
            this.refresh();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/content/ProjectDashboardContentCollectionView.js